import config from '../agentSettings';

const canModify = () => process.env.NODE_ENV === 'development' && config.use;
const modifyUrl = url => {
  if (canModify()) {
    return `${process.env.AGENT_PREFIX}/${url}`.replace(/\/+/gu, '/');
  }
  return url;
};

const modifyHeader = (header = {}) => {
  if (canModify()) {
    header[process.env.AGENT_DOMAIN_KEY] = JSON.parse(process.env.AGENT_DOMAINS)[config.domain];
    header[process.env.AGENT_COOKIE_KEY] = config.cookie;
  }
  return header;
};

export { modifyUrl, modifyHeader };
